import React, { useEffect } from "react";

import "./ticket.css";

const Ticket = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container servicios-container">
      <div className='row'>
            <div className='col_12'>
                <div className='servicios_title'>
                    <h1>Ticket De Mantenimiento</h1>
                </div>
            </div>
        </div>
      <div className="row">   
      <form class="row g-3">
  <div class="col-md-4">
    <label for="validationServer01" class="form-label">N de inventario</label>
    <input type="text" class="form-control is-valid" id="validationServer01" required/>
    
  </div>
  <div class="col-md-4">
    <label for="validationServer02" class="form-label">Fecha</label>
    <input type="date" class="form-control is-valid" id="validationServer02" required/>
    
  </div>
  <div class="col-md-4">
    <label for="validationServer02" class="form-label">N de empleado</label>
    <input type="text" class="form-control is-valid" id="validationServer02"  required/>
    
  </div>
  <div class="col-12">
    <label for="validationTextarea" class="form-label">Descripcion de la falla</label>
    <textarea class="form-control is-invalid" id="validationTextarea" placeholder="Describe la falla que presenta el equipo" required></textarea>
    
  </div>
  
  
  <div class="col-12">
    <div class="form-check">

      <div id="invalidCheck3Feedback" class="invalid-feedback">
        You must agree before submitting.
      </div>
    </div>
  </div>
  <div class="col-12">
    <button class="btn btn-primary" type="submit">Enviar ticket</button>
  </div>
</form>
       
      </div>
      <hr className="hr-gob" />
    </div>
  );
};

export default Ticket;

 